<div class="fixed top-16 right-6 z-[80] flex flex-col gap-3">
  <div
    *ngFor="let op of visibleOperations()"
    class="relative flex items-center gap-3 bg-white dark:bg-gray-800 border rounded-lg shadow-lg pl-5 pr-8 py-4 max-w-sm"
    [ngClass]="op.colorProfile === 'red' ? 'border-red-200 dark:border-red-700' : 'border-green-200 dark:border-green-700'"
    role="status"
    aria-live="polite"
  >
    <button
      type="button"
      (click)="dismiss(op.id)"
      class="absolute top-1.5 right-1.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 rounded p-0.5"
      [attr.aria-label]="'Dismiss' | transloco"
    >
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
    <svg
      class="animate-spin h-5 w-5 shrink-0"
      [ngClass]="op.colorProfile === 'red' ? 'text-red-600' : 'text-green-600'"
      xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
    >
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
    </svg>
    <div>
      <p class="text-sm font-medium text-gray-800 dark:text-white">{{ op.message | transloco }}</p>
      <p *ngIf="op.subMessage" class="text-xs text-gray-500 dark:text-gray-400">{{ op.subMessage | transloco }}</p>
    </div>
  </div>
</div>

